/**
 * Small tags for what the client is on: their team(s) and their current
 * program. Shown under the Home greeting and on the Calendar.
 */
import { Dumbbell, Users } from 'lucide-react';
import type { MyTeam } from '@/lib/useMyTeams';

export function AssignmentTags({ teams, programName }: { teams: MyTeam[]; programName: string | null | undefined }) {
  if (!teams.length && !programName) return null;
  const pill = {
    display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: '0.72rem', fontWeight: 600,
    padding: '0.2rem 0.6rem', borderRadius: 999, lineHeight: 1.4,
  } as const;
  return (
    <div className="flex flex-wrap gap-1.5">
      {teams.map((t) => (
        <span key={t.id} style={{ ...pill, background: 'rgba(201,168,106,0.15)', color: 'var(--champagne)', border: '1px solid var(--gold-muted)' }}>
          <Users size={12} /> {t.name}
        </span>
      ))}
      {programName && (
        <span style={{ ...pill, background: 'rgba(255,255,255,0.06)', color: 'var(--cream)', border: '1px solid rgba(255,255,255,0.12)' }}>
          <Dumbbell size={12} /> {programName}
        </span>
      )}
    </div>
  );
}
